import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, Badge, Row, Col, Tab, Nav, Tooltip, OverlayTrigger } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/idly.png'; // fallback or default image

const ItemStagingView = ({ show, onClose, data , selectedRow}) => {
    const [key, setKey] = useState('morning_stage');

    const scheduleMap = {
        Morning: 'morning_stage',
        Noon: 'noon_stage',
        Night: 'night_stage',
    };

    const getScheduleKey = (name) => scheduleMap[name] || name.toLowerCase() + '_stage';

    useEffect(() => {
        // Set default tab on open
        if (show && data?.schedules_with_stagging?.length) {
            const defaultSchedule = data.schedules_with_stagging[0].schedule.itemschedule_name;
            setKey(getScheduleKey(defaultSchedule));
        }
    }, [show, data]);

    const renderTime = (timeStr) => {
        if (!timeStr) return '-';
        const [h, m] = timeStr.split(':');
        const hours = parseInt(h, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHour = hours % 12 || 12;
        return `${displayHour}:${m} ${ampm}`;
    };


    console.log("Quantity:", data?.item_quantity_name);
console.log("Weight:", data?.item_weight);
console.log("Size:", data?.item_size);


    return (
        <Modal show={show} size="xl">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Item Staging</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <Row className="mb-3">
                        <Col lg={12}>
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                    <div data-src={data?.item?.item_image || idly} className='border rounded px-1 py-0'>
                                        <img src={data?.item?.item_image || idly} alt={data?.item?.item_name || 'Item'} className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <label className='text-black font-w400 fs-5'>{data?.item?.item_name || '-'}</label>
                                    <label className='text-black mx-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>{data?.item?.itemcategory_name || '-'}</label>
                                    <label className='text-black mx-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>{data?.item?.itemsubcategory_name || '-'}</label>
                                    <div className='d-block mt-1'>
                                        <label className='text-black font-w400 fs-7'>Quantity</label>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>  {data?.item?.item_quantity_name || 'ss'}</Badge>
                                        <label className='text-black mx-2'>|</label>
                                        <label className='text-black font-w400 fs-7'>Weight</label>
                                        <Badge bg="success" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>{data?.item?.item_weight || '70 gms'}</Badge>
                                        <label className='text-black mx-2'>|</label>
                                        <label className='text-black font-w400 fs-7'>Size</label>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>{data?.item?.item_size || '9 cm'}</Badge>
                                    </div>
                                </div> 

                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                                <Nav as="ul" className="nav-tabs">
                                    {data?.schedules_with_stagging?.map((sched, idx) => (
                                        <Nav.Item as="li" key={idx}>
                                            <Nav.Link eventKey={getScheduleKey(sched.schedule.itemschedule_name)}>
                                                <label className="fs-6">{sched.schedule.itemschedule_name}</label>
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
                                </Nav>

                                <Tab.Content className="pt-4">
                                    {data?.schedules_with_stagging?.map((sched, idx) => (
                                        <Tab.Pane eventKey={getScheduleKey(sched.schedule.itemschedule_name)} key={idx}>
                                            <Row>
                                                <Col xl={12}>
                                                    <div className="table-container">
                                                        <table className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                            <thead>
                                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                                    <th className='min-w-100px text-start'>Staging Name</th>
                                                                    <th className='min-w-100px'>Production <span>ST / ET</span></th>
                                                                    <th className='min-w-100px'>Timing / Work Hours</th>
                                                                    <th className='min-w-100px'>Work <span>ST / ET</span></th>
                                                                    <th className='min-w-100px text-center'>Total Duration</th>
                                                                    <th className='min-w-100px'>Description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                                {sched.stagging?.map((stag, stagIdx) => (
                                                                    <tr key={stagIdx}>
                                                                        <td>{stag.item_stagging_name}</td>
                                                                        <td>{renderTime(sched.schedule.production_start_time)} | {renderTime(sched.schedule.production_end_time)}</td>
                                                                        <td>
                                                                            Before Production
                                                                            <div><small>{stag.working_hours}</small></div>
                                                                        </td>
                                                                        <td>{renderTime(stag.start_time)} | {renderTime(stag.end_time)}</td>
                                                                        <td className="text-center">{stag.work_duration}</td>
                                                                        <td>{stag.description || '-'}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </Tab.Container>
                        </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default ItemStagingView;
